import React from 'react'
import classNames from 'classnames'
import Container from '../common/Container'
import { Link } from 'gatsby'
import { isLocalLink } from '../../helpers/url'
import { ReactComponent as CloseIconSVG } from './CloseIconSVG.svg'
import { ReactComponent as NotificationBellSVG } from './NotificationBellSVG.svg'

import styles from './HeaderBar.module.scss'

export interface headerBarProps {
  children: React.ReactNode
  linkUrl?: string
  arrowText?: string
  showNotificationBell?: boolean
  showEmoji?: boolean
  emoji?: string
  theme?: HeaderBarTheme
  onClose?: () => void
}

export enum HeaderBarTheme {
  Default = 'Default',
  Bright = 'Bright',
  Dark = 'Dark',
}

export default function HeaderBar({
  children,
  linkUrl,
  arrowText,
  showNotificationBell,
  showEmoji,
  emoji,
  theme = HeaderBarTheme.Default,
  onClose,
}: headerBarProps) {
  return linkUrl ? (
    <Container
      className={classNames(styles.container, {
        [styles.default]: theme === HeaderBarTheme.Default,
        [styles.bright]: theme === HeaderBarTheme.Bright,
        [styles.dark]: theme === HeaderBarTheme.Dark,
      })}
      size='large'
    >
      <div className={styles.headerBar}>
        <button type='button' aria-label='Close notification' className={styles.closeIcon} onClick={onClose}>
          <CloseIconSVG />
        </button>
        {isLocalLink(linkUrl) ? (
          <Link className={styles.link} to={linkUrl}>
            <div className={styles.textContainer}>
              {showEmoji && emoji}
              {showNotificationBell && <NotificationBellSVG />}
              <div className={styles.text}>{children}</div>
            </div>
            {arrowText && <div className={styles.arrow}>{arrowText} →</div>}
          </Link>
        ) : (
          <a className={styles.link} href={linkUrl} rel='noreferrer'>
            <div className={styles.textContainer}>
              {showEmoji && emoji}
              {showNotificationBell && <NotificationBellSVG />}
              <div className={styles.text}>{children}</div>
            </div>
            {arrowText && <div className={styles.arrow}>{arrowText} →</div>}
          </a>
        )}
      </div>
    </Container>
  ) : (
    <Container
      className={classNames(styles.container, {
        [styles.default]: theme === HeaderBarTheme.Default,
        [styles.bright]: theme === HeaderBarTheme.Bright,
        [styles.dark]: theme === HeaderBarTheme.Dark,
      })}
      size='large'
    >
      <div className={styles.headerBar}>
        <button type='button' aria-label='Close notification' className={styles.closeIcon} onClick={onClose}>
          <CloseIconSVG />
        </button>
        <div className={styles.link}>
          <div className={styles.textContainer}>
            {showEmoji && emoji}
            {showNotificationBell && <NotificationBellSVG />}
            <div className={styles.text}>{children}</div>
          </div>
          {arrowText && <div className={styles.arrow}>{arrowText} →</div>}
        </div>
      </div>
    </Container>
  )
}
